import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
  Col, Row, Card, Icon, Label,
} from 'shpmtcd'

import '../styles/BodyLayout.scss'

import list from './TabList.json'

// sm-breakpoint
const SMALL_DEVICE_MAX_WIDTH = 576
class BodyLayout extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showingCollapseBar: window.innerWidth <= SMALL_DEVICE_MAX_WIDTH,
      collapseExpand: false,
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions)
  }

  updateDimensions = () => {
    if (window.innerWidth <= SMALL_DEVICE_MAX_WIDTH) {
      this.setState({
        showingCollapseBar: true,
      })
    } else {
      this.setState({
        showingCollapseBar: false,
      })
    }
  }

  handleClick = (itemId) => {
    const { onSelect } = this.props
    const { showingCollapseBar } = this.state
    if (showingCollapseBar) {
      this.setState({
        collapseExpand: false,
      })
    }
    onSelect(itemId)
  }

  handleActiveTabClick = () => {
    this.setState({
      collapseExpand: true,
    })
  }

  renderTabList = (tabList, activeId, showingCollapseBar) => (
    tabList.map((item) => (
      <div
        key={item.id}
        className={`tabList-item-wrapper ${activeId === item.id ? 'active' : ''}`}
        onClick={() => this.handleClick(item.id)}
        onKeyDown={() => this.handleClick(item.id)}
      >
        <div className='item-icon-text-wrapper'>
          <Icon type={item.icon} />
          <p className='item-text'>{item.text}</p>
          {
            (item.id === 'wishlist')
              ? (
                <Label
                  type='Primary'
                  style={{
                    right: '5px',
                    position: 'absolute',
                  }}
                >New
                </Label>
              )
              : null
        }
        </div>
        {
          activeId !== item.id
          || (
            <span className={showingCollapseBar ? 'collapse-icon' : ''}>
              <Icon type='shpmtcdicon-arrow-right-thin' />
            </span>
          )
        }
      </div>
    ))
  )

  renderActiveTabItem = (item) => (
    <div
      className='tabList-item-wrapper active'
      onClick={this.handleActiveTabClick}
      onKeyDown={this.handleActiveTabClick}
    >
      <div className='item-icon-text-wrapper'>
        <Icon type={item.icon} />
        <p className='item-text'>{item.text}</p>
      </div>
      <span className='collapse-icon'>
        <Icon type='shpmtcdicon-arrow-right-thin' />
      </span>
    </div>
  )

  render() {
    const { activeId, children } = this.props
    const { collapseExpand, showingCollapseBar } = this.state

    const itemIndex = list.tabList.findIndex((x) => x.id === activeId)
    const activeTabItem = list.tabList[itemIndex]
    return (
      <>
        <Row
          gutter={30}
          style={{ marginTop: '20px' }}
          className={`bodyLayout ${showingCollapseBar ? 'small-screen' : ''}`}
        >
          {
            showingCollapseBar
              ? (
                <div className={`tab-collapsble-List ${collapseExpand && 'active'}`}>
                  <Card style={{ padding: '5px 10px' }}>
                    {
                      collapseExpand
                        ? this.renderTabList(list.tabList, activeId, showingCollapseBar)
                        : this.renderActiveTabItem(activeTabItem)
                    }
                  </Card>
                </div>
              ) : (
                <Col span={6} className='tabList'>
                  <Card style={{ padding: '20px' }}>
                    <h3 className='tabList-title'> My Account </h3>
                    {this.renderTabList(list.tabList, activeId)}
                  </Card>
                </Col>
              )
          }
          <Col
            span={18}
            style={{
              padding: 0,
            }}
            className={`tabPane ${showingCollapseBar ? 'small-screen' : ''}`}
          >
            <Card>
              {children}
            </Card>
          </Col>
        </Row>
      </>
    )
  }
}

BodyLayout.propTypes = {
  activeId: PropTypes.string.isRequired,
  children: PropTypes.element,
  onSelect: PropTypes.func,
}

BodyLayout.defaultProps = {
  children: null,
  onSelect: () => { },
}

export default BodyLayout
